import React, { useEffect, useState } from "react";
import NetworkIcon from "./network-icon";
import { useTheme } from "contexts/ThemeContext";

interface NimSequenceProps {
  // Add your props here
}

const NimSequence: React.FC<NimSequenceProps> = (props) => {
  const { theme } = useTheme();
  const [currentAnimation, setCurrentAnimation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAnimation((prev) => (prev + 1) % 3);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-row items-start">
      <NetworkIcon
        scale={0.3}
        borderColor={"white"}
        nodeColor={theme.highlightColor}
        baseColor={theme.highlightColor}
        baseHighlightColor={theme.highlightColor}
        isAnimating={currentAnimation === 0}
        content={
          <div className="flex flex-col items-center text-center text-primary font-bold text-xl h-full">
            <p>Flexible</p>
          </div>
        }
      />
      <NetworkIcon
        scale={0.5}
        borderColor={"white"}
        nodeColor={theme.highlightColor}
        baseColor={theme.highlightColor}
        baseHighlightColor={theme.highlightColor}
        isAnimating={currentAnimation === 1}
        content={
          <div className="flex flex-col items-center text-center text-primary font-bold text-xl">
            <p>Scalable</p>
          </div>
        }
      />
      <div className="ml-2">
        <NetworkIcon
          scale={0.3}
          borderColor={"white"}
          nodeColor={theme.highlightColor}
          baseColor={theme.highlightColor}
          baseHighlightColor={theme.highlightColor}
          isAnimating={currentAnimation === 2}
          content={
            <div className="flex flex-col items-center text-center text-primary font-bold text-xl">
              <p>Optimized</p>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default NimSequence;
